<template>
  <el-select
    style="width: 300px"
    v-model="localValue"
    :size="size"
    :multiple="multiple"
    :disabled="disabled"
    :clearable="clearable"
    :placeholder="placeholder"
    @change="selected"
    filterable
  >
    <el-option
      v-for="group in groups"
      :key="group.id"
      :label="group.name"
      :value="group.id"
    />
  </el-select>
</template>

<script>
export default {
  name: "groups-select",
  props: {
    value: '',
    size: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: true },
    clearable: { type: Boolean, default: true },
    placeholder: { type: String, default: 'Группа' },
  },
  data() {
    return {
      localValue: this.value,
      groups: [],
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadGroups();
    });
  },
  methods: {
    selected(value) {
      if (value === '') {
        value = null;
      }

      this.localValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    },
    loadGroups() {
      this.$api.group.search()
        .then(({data}) => {
          this.groups = data.groups;
        });
    },
  },
};
</script>

<style scoped>

</style>
